import React, { memo } from 'react';

interface ErrorBoundaryIconProps {
    width?: number;
    height?: number;
    fillColor?: string;
}

export const ErrorBoundaryIcon = memo(({ width=32, height=32, fillColor='#E71218' }: ErrorBoundaryIconProps) => {
    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill='none' xmlns='http://www.w3.org/2000/svg'>
            <rect width={width} height={width} rx='24' fill={fillColor} />
            <path d='M16.0001 9.3335C16.7334 9.3335 17.3334 9.9335 17.3334 10.6668V16.0002C17.3334 16.7335 16.7334 17.3335 16.0001 17.3335C15.2667 17.3335 14.6667 16.7335 14.6667 16.0002V10.6668C14.6667 9.9335 15.2667 9.3335 16.0001 9.3335ZM17.3334 22.6668H14.6667V20.0002H17.3334V22.6668Z' fill='white'/>
        </svg>

    );
});

ErrorBoundaryIcon.displayName = 'ErrorBoundaryIcon';
